module.exports = __webpack_public_path__ + "img/trackedimageanchor.317c6635.jpg";